import axios from 'axios'
import store from '@/store'

const API_BASE_URL = 'https://empresa-service.intrare.app'

class SecurityService {
  constructor() {
    this.apiUrl = `${API_BASE_URL}/security`
  }

  getAuthHeaders(multipart = false) {
    const token = store.getters.getToken || localStorage.getItem('user-token')
    const headers = {
      'Authorization': `Token ${token}`
    }
    // Al enviar FormData dejamos que el navegador defina el Content-Type con el boundary
    if (!multipart) {
      headers['Content-Type'] = 'application/json'
    }
    return headers
  }

  // Obtener guardia por código QR
  async getGuardByQR(uniqueCode) {
    try {
      const response = await axios.get(
        `${this.apiUrl}/guards/by-qr/${uniqueCode}`,
        { headers: this.getAuthHeaders() }
      )
      return {
        success: true,
        data: response.data.data
      }
    } catch (error) {
      console.error('Error obteniendo guardia por QR:', error)
      return {
        success: false,
        error: (error.response && error.response.data && error.response.data.error) || error.message
      }
    }
  }

  // Obtener registro de hoy
  async getTodayAttendance(guardId) {
    try {
      const response = await axios.get(
        `${this.apiUrl}/attendance/${guardId}/today/`,
        { headers: this.getAuthHeaders() }
      )
      return {
        success: true,
        data: response.data.data
      }
    } catch (error) {
      console.error('Error obteniendo registro de hoy:', error)
      return {
        success: false,
        error: (error.response && error.response.data && error.response.data.error) || error.message
      }
    }
  }

  // Registrar entrada
  async registerEntrada(guardId, empresaAsignadaId, fotoEntrada = null) {
    try {
      const formData = new FormData()
      formData.append('guard_id', guardId)
      formData.append('empresa_asignada_id', empresaAsignadaId)
      if (fotoEntrada) {
        formData.append('foto_entrada', fotoEntrada, 'entrada.jpg')
      }

      const response = await axios.post(
        `${this.apiUrl}/attendance/entrada/`,
        formData,
        { headers: this.getAuthHeaders(true) }
      )
      return {
        success: true,
        data: response.data.data,
        message: response.data.message
      }
    } catch (error) {
      console.error('Error registrando entrada:', error)
      return {
        success: false,
        error: (error.response && error.response.data && error.response.data.error) || error.message
      }
    }
  }

  // Registrar salida
  async registerSalida(attendanceId, fotoSalida = null) {
    try {
      const formData = new FormData()
      if (fotoSalida) {
        formData.append('foto_salida', fotoSalida, 'salida.jpg')
      }

      const response = await axios.post(
        `${this.apiUrl}/attendance/${attendanceId}/salida/`,
        formData,
        { headers: this.getAuthHeaders(true) }
      )
      return {
        success: true,
        data: response.data.data,
        message: response.data.message
      }
    } catch (error) {
      console.error('Error registrando salida:', error)
      return {
        success: false,
        error: (error.response && error.response.data && error.response.data.error) || error.message
      }
    }
  }

  // Obtener empresas/clientes con contrato activo (para saber en qué planta trabajarán)
  async getActiveCompanies() {
    try {
      const response = await axios.get(
        `${this.apiUrl}/my-company/`,
        { headers: this.getAuthHeaders() }
      )
      const contracts = response.data.company_contracts || response.data.contracts || []
      const activeContracts = contracts
        .filter(contract => contract.status === 'ACTIVE')
        .map(contract => ({
          id: contract.company_id,
          name: contract.company_name
        }))
      return {
        success: true,
        data: activeContracts
      }
    } catch (error) {
      console.error('Error obteniendo empresas:', error)
      return {
        success: false,
        error: (error.response && error.response.data && error.response.data.error) || error.message
      }
    }
  }

  // Obtener historial de asistencia
  async getAttendanceHistory(params = {}) {
    try {
      const queryParams = new URLSearchParams()
      if (params.start_date) queryParams.append('start_date', params.start_date)
      if (params.end_date) queryParams.append('end_date', params.end_date)
      if (params.guard_id) queryParams.append('guard_id', params.guard_id)
      if (params.empresa_id) queryParams.append('empresa_id', params.empresa_id)
      if (params.guardia_name) queryParams.append('guardia_name', params.guardia_name)
      if (params.page) queryParams.append('page', params.page)
      if (params.limit) queryParams.append('limit', params.limit)

      const response = await axios.get(
        `${this.apiUrl}/attendance/history/?${queryParams}`,
        { headers: this.getAuthHeaders() }
      )
      return {
        success: true,
        data: response.data.data
      }
    } catch (error) {
      console.error('Error obteniendo historial:', error)
      return {
        success: false,
        error: (error.response && error.response.data && error.response.data.error) || error.message
      }
    }
  }

  // Obtener detalle diario consolidado (incluye fotos de entrada/salida y horas trabajadas)
  async getDailyAttendance(params = {}) {
    try {
      const queryParams = new URLSearchParams()
      if (params.date) queryParams.append('date', params.date)
      if (params.guard_id) queryParams.append('guard_id', params.guard_id)
      if (params.empresa_id) queryParams.append('empresa_id', params.empresa_id)

      const response = await axios.get(
        `${this.apiUrl}/attendance/daily/?${queryParams}`,
        { headers: this.getAuthHeaders() }
      )
      return {
        success: true,
        date: response.data.date,
        total: response.data.total_registros,
        data: response.data.data
      }
    } catch (error) {
      console.error('Error obteniendo detalle diario:', error)
      return {
        success: false,
        error: (error.response && error.response.data && error.response.data.error) || error.message
      }
    }
  }
}

export const securityService = new SecurityService()
